<template>
  <div
    class="group rounded mb-4"
    :class="[
      'depth-' + depth,
      {
        'elevation-2 mt-2': depth === 1
      }
    ]"
  >
    <div class="grey lighten-5 wrapper d-flex flex-column">
      <div class="header rounded-tr px-4 py-3">
        <div class="d-flex align-center">
          <label class="mr-2" for="vqb-match-type">
            {{ labels.matchType }}
          </label>

          <v-select
            id="vqb-match-type"
            v-model="query.logicalOperator"
            rounded
            dense
            solo
            flat
            hide-details
            :items="
              labels.matchTypes.map(x => ({ text: x.label, value: x.id }))
            "
            :disabled="locked"
            style="max-width: 120px"
          >
          </v-select>
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                elevation="0"
                v-if="depth > 1"
                @click="remove"
                v-on="on"
                v-bind="attrs"
                :disabled="locked"
              >
                <v-icon small>$close</v-icon>
              </v-btn>
            </template>
            <span>Remove</span>
          </v-tooltip>
        </div>
      </div>

      <div
        v-if="$props.query.children && $props.query.children.length === 0"
        class="py-12 px-8 text-center grey--text"
      >
        -- Empty --
      </div>
      <div v-else class="pa-12 overflow-hidden">
        <rule-children v-bind="$props" :locked="locked" />
      </div>
      <v-divider class="mx-3"></v-divider>
      <div class="d-flex px-4 py-3">
        <div class="d-flex flex-fill">
          <v-select
            placeholder="Rule For..."
            v-model="selectedRule"
            dense
            outlined
            :items="rules.map(x => ({ text: x.label, value: x }))"
            class="flex-fill rounded-r-0"
            hide-details
            :disabled="locked"
          >
          </v-select>

          <v-btn
            color="primary"
            class="rounded-l-0 mr-2"
            style="height: 100% !important"
            @click="addRule"
            :disabled="locked"
          >
            + Rule
          </v-btn>

          <v-btn
            v-if="depth < maxDepth"
            color="primary"
            style="height: 100% !important"
            @click="addGroup"
            :disabled="locked"
          >
            + Group
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QueryBuilderGroup from "vue-query-builder/dist/group/QueryBuilderGroup.umd.js";
import QueryBuilderRule from "./QuestionRules.Rule.vue";
import RuleChildren from "./QuestionRules.Children.vue";

export default {
  name: "QueryBuilderGroup",
  props: {
    locked: Boolean
  },
  components: {
    // eslint-disable-next-line vue/no-unused-components
    QueryBuilderRule,
    RuleChildren
  },
  extends: QueryBuilderGroup
};
</script>

<style lang="scss">
.vue-query-builder {
  .group {
    overflow: hidden;

    .header {
      background: #d5d5d5;
    }
    &.depth-1 {
      border-left: 4px var(--v-secondary-lighten1) solid;
      // .header {
      //   background: rgba(0, 0, 0, 0.2);
      // }

      & .rule {
        background: #ddd;
      }
    }

    &.depth-1 .rule,
    &.depth-2 {
      border-left: 4px var(--v-success-base) solid;
      border-top: 1px solid #d5d5d5;
      border-right: 1px solid #d5d5d5;
      border-bottom: 1px solid #d5d5d5;

      .header,
      .rule {
        background: #ddd;
      }
    }

    &.depth-2 .rule,
    &.depth-3 {
      border-left: 4px var(--v-error-base) solid;
      border-top: 1px solid #d5d5d5;
      border-right: 1px solid #d5d5d5;
      border-bottom: 1px solid #d5d5d5;

      .header,
      .rule {
        background: #ddd;
      }
    }

    &.depth-3 .rule {
      border-left: 4px var(--v-primary-base) solid;
      border-top: 1px solid #d5d5d5;
      border-right: 1px solid #d5d5d5;
      border-bottom: 1px solid #d5d5d5;
      background: #ddd;
    }
  }
}

.vue-query-builder .vqb-group.depth-1 .vqb-rule,
.vue-query-builder .vqb-group.depth-2 {
  border-left: 2px solid #8bc34a;
}

.vue-query-builder .vqb-group.depth-2 .vqb-rule,
.vue-query-builder .vqb-group.depth-3 {
  border-left: 2px solid #00bcd4;
}

.vue-query-builder .vqb-group.depth-3 .vqb-rule,
.vue-query-builder .vqb-group.depth-4 {
  border-left: 2px solid #ff5722;
}

.vue-query-builder .close {
  opacity: 1;
  color: rgb(150, 150, 150);
}

@media (min-width: 768px) {
  .vue-query-builder .vqb-rule.form-inline .form-group {
    display: block;
  }
}
</style>
